import React from 'react';
import './style.css';

class Fade extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      fade: false,
    };
  }

  componentDidMount = () => {
    this.setState({
      fade: true,
    });
  };

  render() {
    const style = this.state.fade
    return <div className={style ? "load" : "fade" }>{this.props.children}</div>;
  }
}

export default Fade;



// WEBPACK FOOTER //
// ./src/animation/Fade/index.js